import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ApplicationVersionService {
  private readonly httpClient = inject(HttpClient);

  getApplicationVersion(): Observable<string> {
    const url = 'api/v1/application-settings/version';

    return this.httpClient.get(environment.portalApiUrl + url, { responseType: 'text' });
  }
}
